/* reprocell-plp.js — PLP interactivity */
(function () {
  'use strict';

  var cfg = window.RC_PLP || {};

  /* ── Helpers ── */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* Refresh the header cart count after an on-page add (no full reload). */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('.js-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  /* Re-render the cart drawer from a Section Rendering API response and open it,
     so its contents match the cart after an on-page add (no reload needed). */
  function syncCartDrawer(res) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !res || !res.sections || !res.sections['cart-drawer']) return;
    try {
      var fresh = new DOMParser()
        .parseFromString(res.sections['cart-drawer'], 'text/html')
        .querySelector('#CartDrawer');
      var target = document.getElementById('CartDrawer');
      if (!fresh || !target) return;
      target.innerHTML = fresh.innerHTML;
      drawer.classList.remove('is-empty');
      var overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', function () { drawer.close(); });
      if (typeof drawer.open === 'function') drawer.open();
    } catch (e) {}
  }

  /* ── Grand Total ── */

  function updateGrandTotal() {
    var total = 0;
    var listWrap = qs('.rc-plp-list-wrap');
    if (listWrap) {
      qsa('.rc-qty-stepper', listWrap).forEach(function (stepper) {
        var qty = parseInt(qs('.rc-qty-input', stepper).value, 10) || 0;
        var price = parseInt(stepper.dataset.price, 10) || 0;
        total += qty * price;
      });
    }
    var el = qs('.rc-grand-total-amount');
    if (el) el.textContent = formatMoney(total);
  }

  /* ── Qty Steppers (list view) ── */

  function updateRowTotal(stepper) {
    var row = stepper.closest('tr');
    if (!row) return;
    var cell = qs('.rc-row-total', row);
    if (!cell) return;
    var qty = parseInt(qs('.rc-qty-input', stepper).value, 10) || 0;
    var price = parseInt(stepper.dataset.price, 10) || 0;
    cell.textContent = formatMoney(qty * price);
    updateGrandTotal();
  }

  function initSteppers() {
    qsa('.rc-qty-stepper').forEach(function (stepper) {
      var input = qs('.rc-qty-input', stepper);

      qs('.rc-qty-minus', stepper).addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        if (v > 0) { input.value = v - 1; updateRowTotal(stepper); }
      });

      qs('.rc-qty-plus', stepper).addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        input.value = v + 1;
        updateRowTotal(stepper);
      });

      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        input.value = (isNaN(v) || v < 0) ? 0 : v;
        updateRowTotal(stepper);
      });
    });
  }

  /* ── Bulk Add to Cart ── */

  function initAddAll() {
    var btn = qs('.rc-plp-add-all-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var items = [];
      qsa('.rc-qty-stepper').forEach(function (stepper) {
        var row = stepper.closest('tr');
        if (row && row.hidden) return;
        var qty = parseInt(qs('.rc-qty-input', stepper).value, 10) || 0;
        if (qty > 0) {
          items.push({ id: parseInt(stepper.dataset.variantId, 10), quantity: qty });
        }
      });

      if (!items.length) {
        alert('Set a quantity on at least one item first.');
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          qsa('.rc-qty-input').forEach(function (i) { i.value = 0; });
          qsa('.rc-row-total').forEach(function (c) { c.textContent = '$0.00'; });
          updateGrandTotal();
          refreshCartCount();
          syncCartDrawer(res);
          btn.textContent = 'Added!';
          setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 2000);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
          alert('Error adding to cart. Please try again.');
        });
    });
  }

  /* ── Grid single-variant Add to Cart (reads qty from card stepper) ── */

  function initGridAddBtns() {
    qsa('.rc-grid-add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.dataset.variantId, 10);
        var body = btn.closest('.rc-product-card__body');
        var stepper = body ? qs('.rc-card-stepper', body) : null;
        var qty = stepper ? (parseInt(qs('.rc-qty-input', stepper).value, 10) || 1) : 1;

        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: 'cart-drawer', sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (stepper) qs('.rc-qty-input', stepper).value = 0;
            btn.textContent = 'Added!';
            refreshCartCount();
            syncCartDrawer(res);
            setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 2000);
          })
          .catch(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; });
      });
    });
  }

  /* ── Quote counter (header span) ── */

  function updateQuoteCounter(delta) {
    var el = document.getElementById('quoteCount');
    if (!el) return;
    var current = parseInt(el.textContent, 10) || 0;
    el.textContent = Math.max(0, current + delta);
  }

  function syncQuoteCounter() {
    var el = document.getElementById('quoteCount');
    if (!el) return;
    try {
      var ids = JSON.parse(localStorage.getItem('rc_quote_ids') || '[]');
      el.textContent = ids.length;
    } catch (e) {}
  }

  /* ── Grid quote (heart) button ── */

  function addToQuote(btn) {
    var variantId   = parseInt(btn.dataset.variantId, 10);
    var productId   = parseInt(btn.dataset.productId, 10);
    var hasVariants = btn.dataset.hasVariants === '1';

    /* Multi-variant: send to product page so customer picks a variant */
    if (hasVariants || !variantId) {
      window.location.href = btn.dataset.productUrl;
      return;
    }

    /* Add to the SA Request a Quote app list via its storefront API.
       NOTE: pass RAW (unencoded) strings — the app encodes internally. */
    if (!window.GRFQApp || typeof window.GRFQApp.addQuoteItem !== 'function') {
      /* App not loaded — fall back to the product page */
      window.location.href = btn.dataset.productUrl;
      return;
    }

    btn.disabled = true;

    /* Add the item once the app's quote-storage module is initialized. */
    function doAdd() {
      try {
        var priceCents = String(Math.round(
          parseFloat((btn.dataset.productPrice || '0').replace(/[^0-9.]/g, '')) * 100
        ));

        window.GRFQApp.addQuoteItem({
          product_id:   productId,
          variant_id:   variantId,
          name:         btn.dataset.productTitle || '',
          variant_name: btn.dataset.variantName  || '',
          options:      btn.dataset.variantName  || '',
          sku:          btn.dataset.sku          || '',
          vendor:       btn.dataset.productVendor || '',
          image:        btn.dataset.productImage  || '',
          product_url:  btn.dataset.productUrl    || '',
          price:        priceCents,
          qty:          1
        });

        btn.classList.add('is-quoted');
        if (typeof window.GRFQApp.quoteCounter === 'function') {
          var el = document.getElementById('quoteCount');
          if (el) el.textContent = window.GRFQApp.quoteCounter();
        }
      } catch (e) {
        window.location.href = btn.dataset.productUrl;
      } finally {
        btn.disabled = false;
      }
    }

    /* Warm up the app's quote store, then add. Prevents a fast click on a
       fresh page load from adding to memory but never persisting. */
    try {
      if (typeof window.GRFQApp.getQuoteItems === 'function') {
        window.GRFQApp.getQuoteItems();
      }
      var warm = (typeof window.GRFQApp.handleQuoteFunction === 'function')
        ? window.GRFQApp.handleQuoteFunction()
        : null;
      if (warm && typeof warm.then === 'function') {
        warm.then(doAdd, doAdd);
      } else {
        setTimeout(doAdd, 300);
      }
    } catch (e) {
      setTimeout(doAdd, 300);
    }
  }

  function initGridQuoteBtns() {
    /* Restore quoted state from localStorage */
    var quoted = [];
    try { quoted = JSON.parse(localStorage.getItem('rc_quote_ids') || '[]'); } catch (e) {}

    qsa('.rc-grid-quote-btn').forEach(function (btn) {
      var id = parseInt(btn.dataset.productId, 10);
      if (quoted.includes(id)) btn.classList.add('is-quoted');

      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-quoted')) return; /* already added */
        addToQuote(btn);
      });
    });

    syncQuoteCounter();
  }

  /* ── List / Grid Toggle ── */

  function initViewToggle() {
    var container = document.getElementById('rc-plp-views');
    var listBtn   = qs('.rc-toggle-list');
    var gridBtn   = qs('.rc-toggle-grid');
    if (!container) return;

    function setView(view) {
      container.classList.remove('rc-view-list', 'rc-view-grid');
      container.classList.add('rc-view-' + view);
      if (listBtn) listBtn.classList.toggle('is-active', view === 'list');
      if (gridBtn) gridBtn.classList.toggle('is-active', view === 'grid');
      try { localStorage.setItem('rc_plp_view', view); } catch (e) {}
    }

    var saved = 'list';
    try { saved = localStorage.getItem('rc_plp_view') || 'list'; } catch (e) {}
    setView(saved);

    if (listBtn) listBtn.addEventListener('click', function () { setView('list'); });
    if (gridBtn) gridBtn.addEventListener('click', function () { setView('grid'); });
  }

  /* ── Sort ── */

  function initSort() {
    var sel = document.getElementById('rc-sort-select');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sel.value);
      window.location.search = params.toString();
    });
  }

  /* ── Native filter form (Brand / Price / Availability) ──
     Filtering is server-side via Shopify storefront filters. Submitting the
     form reloads the page with the selected filters in the URL; Shopify
     returns the already-filtered, paginated collection.products. */

  function initFilterForm() {
    var form = document.getElementById('rc-filters-form');
    if (!form) return;

    /* Checkboxes submit immediately; price fields submit on blur/change. */
    form.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input')) form.submit();
    });

    /* Let Enter in a price field apply without waiting for blur. */
    qsa('.rc-filter-price input', form).forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
      });
    });
  }

  /* ── "See more" toggle ── */

  function initSeeMore() {
    qsa('.rc-filter-seemore').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = document.getElementById(btn.dataset.target);
        if (!list) return;
        var expanded = btn.dataset.expanded === 'true';
        qsa('.rc-filter-item--overflow', list).forEach(function (item) {
          item.classList.toggle('is-visible', !expanded);
        });
        btn.textContent = expanded ? 'See more' : 'See less';
        btn.dataset.expanded = expanded ? 'false' : 'true';
      });
    });
  }

  /* ── Recently Viewed (render on PLP from localStorage) ── */

  function renderRecentlyViewed() {
    var section = document.getElementById('rc-recently-viewed-section');
    var grid = document.getElementById('rc-recently-viewed-grid');
    if (!section || !grid) return;

    var viewed = [];
    try { viewed = JSON.parse(localStorage.getItem('rc_recently_viewed') || '[]'); } catch (e) {}
    if (!viewed.length) return;

    section.hidden = false;

    grid.innerHTML = viewed.slice(0, 4).map(function (p) {
      var imgHtml = p.image
        ? '<img src="' + p.image + '" alt="" loading="lazy" width="400" height="400">'
        : '<div class="rc-product-card__no-img"></div>';
      return '<div class="rc-product-card">' +
        '<a href="' + p.url + '" class="rc-product-card__img-wrap">' + imgHtml + '</a>' +
        '<div class="rc-product-card__body">' +
        '<h3 class="rc-product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
        '<p class="rc-product-card__price">' + p.price + '</p>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  /* ── Mobile sidebar toggle ── */

  function initSidebarToggle() {
    var btn = qs('.rc-sidebar-toggle');
    var sidebar = document.getElementById('rc-plp-sidebar');
    if (!btn || !sidebar) return;

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sidebar.classList.toggle('rc-sidebar--collapsed', expanded);
    });
  }

  /* ── Boot ── */

  document.addEventListener('DOMContentLoaded', function () {
    initSteppers();
    initAddAll();
    initGridAddBtns();
    initGridQuoteBtns();

    initViewToggle();

    initSort();
    initFilterForm();
    initSeeMore();
    initSidebarToggle();
    renderRecentlyViewed();
  });

})();
